<template>
    <div class="folder_card" v-for="index in $store.state.pageShimmerSize" :key="index">
        <div class="card-bodyx_shimmar d-flex shimmer-line shimmer shimmer-animate mb-2" >                        
        </div>
    </div>
</template>
<script>
export default {
    name: 'ShimmerFolderComponent'
}
</script>